import type { ActionReducerMap } from '@ngrx/store';
import type { AppState } from 'app/store/app.state';
import { combineReducers } from '@ngrx/store';
import { devReducers } from 'app/store/dev/dev.reducer';
import { loginReducer } from 'app/store/login/login.reducer';
import { rootReducer } from 'app/store/root/root.reducer';
import { projectReducers } from './project/project.reducer';

export const appReducers: ActionReducerMap<AppState, any> = {
  login: combineReducers(loginReducer),
  project: combineReducers(projectReducers),
  root: combineReducers(rootReducer),
  dev: combineReducers(devReducers),
};
